/**
 * 创建离线包 body 拓扑资产的复合索引键。
 *
 * @param input body 绑定与几何对象身份。
 * @returns 可用于 Map 的稳定复合键。
 */
export function createPuppyBodyTopologyAssetKey(input: {
  readonly bodyBindingId: string | null | undefined
  readonly geometryObjectId: string | null | undefined
}): string {
  const bodyBindingId = typeof input.bodyBindingId === 'string' ? input.bodyBindingId.trim() : ''
  const geometryObjectId = typeof input.geometryObjectId === 'string' ? input.geometryObjectId.trim() : ''
  return `${bodyBindingId.length}:${bodyBindingId}|${geometryObjectId.length}:${geometryObjectId}`
}
